import { render } from "./BackHomepageComp.vue?vue&type=template&id=6e6679f2"
const script = {}

import "./BackHomepageComp.vue?vue&type=style&index=0&id=6e6679f2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__